/* W9 search (2026-10-24): the header search box's own suggestions panel, used when the W9 header's "Search box"
   setting is "Warp 9 search" (the other choice is Doofinder). Markup and settings: sections/w9-header.liquid.
   - Shopify's predictive search gives products, collections and search suggestions.
   - The My bike list (sections/w9-bike-data, same cache as the header) finds the bike in what was typed, so years
     and nicknames still work ("2016 surron light bee", "drz400sm", "ktm 450"), and links its parts, its wheel
     builder (the header's Wheel builder link blocks) and "Save as My bike".
   - templates/search.w9count gives the result count; templates/collection.w9handles lists a bike collection's
     products, which marks the parts that fit the rider's saved bike.
   Fires w9:search and w9:search-click on document for a later search log. */
(function () {
  'use strict';
  var input = document.getElementById('w9h-q');
  var panel = document.querySelector('[data-w9s]');
  if (!input || !panel || !input.form) return;

  var form = input.form;
  var body = panel.querySelector('[data-w9s-body]');
  var cancel = form.querySelector('[data-w9s-cancel]');
  var cfg = {};
  try { cfg = JSON.parse(panel.querySelector('[data-w9s-config]').textContent); } catch (e) {}
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var SEARCH = cfg.searchUrl || ROOT + 'search';
  var KEY = 'w9_bike';
  var DATA_KEY = 'w9h_bikes_v1';
  var YEAR = /^(19|20)\d{2}$/;
  var desk = window.matchMedia('(min-width: 990px)');
  var popular = (cfg.popular || []).map(function (s) { return String(s).trim(); }).filter(Boolean);
  var builders = cfg.builders || [];

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }
  function link(href, cls, text) { var a = el('a', cls, text); a.href = href; return a; }
  function norm(s) { return String(s || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim(); }
  function compact(s) { return norm(s).replace(/ /g, ''); }
  function okUrl(u) { return typeof u === 'string' && /^\/(?!\/)/.test(u) && u.charAt(1) !== '#'; }
  function readBike() { try { var b = JSON.parse(localStorage.getItem(KEY) || 'null'); return b && b.label ? b : null; } catch (e) { return null; } }
  function collHandle(url) { var m = String(url || '').match(/\/collections\/([^/?#]+)/); return m ? decodeURIComponent(m[1]) : ''; }
  /* Make pages (2026-10-25, Sheldon): a shopper never lands on a whole make or bike type from search. A model's
     link counts as its own page unless it is the make's page; a make that links straight to its only model
     (Y-Volt -> /collections/surge-v) still counts when the handle names the model. */
  var TYPE_PAGES = ['e-moto', 'gas-moto', 'motorcross', 'mx-enduro', 'supermoto-bikes', 'adventure-bikes', 'emoto'];
  function hz(s) { return norm(s).replace(/ /g, '-'); }
  function modelPage(make, model) {
    var h = collHandle(model && model.url);
    if (!h) return false;
    var makeLevel = h === hz(make.label) || h === collHandle(make.url);
    return !makeLevel || compact(h).indexOf(model.key) >= 0;
  }
  var makePages = null;
  function isMakePage(url) {
    var h = collHandle(url);
    if (!h) return false;
    if (TYPE_PAGES.indexOf(h) >= 0) return true;
    if (!makePages) {
      makePages = {};
      (makes || []).forEach(function (m) {
        makePages[hz(m.label)] = 1;
        var mh = collHandle(m.url);
        if (mh && !m.models.some(function (md) { return compact(mh).indexOf(md.key) >= 0; })) makePages[mh] = 1;
      });
    }
    return !!makePages[h];
  }
  function prodHandle(url) { var m = String(url || '').match(/\/products\/([^/?#]+)/); return m ? decodeURIComponent(m[1]) : ''; }
  var money = (function () {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    var f = null;
    try { f = new Intl.NumberFormat(document.documentElement.lang || undefined, { style: 'currency', currency: cur }); } catch (e) {}
    return function (v) { var n = parseFloat(v); if (isNaN(n)) return ''; return f ? f.format(n) : '$' + n.toFixed(2); };
  })();
  function fire(name, detail) { try { document.dispatchEvent(new CustomEvent(name, { detail: detail })); } catch (e) {} }

  /* ---- the My bike list, shared with the header (same fetch, same sessionStorage key) ---- */
  var makes = null;
  var bikesLoading = null;
  function prep(list) {
    return list.filter(function (m) { return m && m.label; }).map(function (m) {
      return {
        group: m.group, label: m.label, url: m.url, key: compact(m.label),
        models: (m.models || []).map(function (md) {
          return { label: md.label, url: md.url, key: compact(md.label), lead: norm(md.label).split(' ')[0] };
        })
      };
    });
  }
  function loadBikes() {
    if (makes) return Promise.resolve(makes);
    if (bikesLoading) return bikesLoading;
    try {
      var c = JSON.parse(sessionStorage.getItem(DATA_KEY) || 'null');
      if (c && c.makes) { makes = prep(c.makes); return Promise.resolve(makes); }
    } catch (e) {}
    bikesLoading = fetch(ROOT + '?section_id=w9-bike-data', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        var m = html.match(/<script[^>]*data-w9-bike-data[^>]*>([\s\S]*?)<\/script>/);
        var data = JSON.parse(m ? m[1] : 'null');
        if (!data || !data.makes || !data.makes.length) throw new Error('empty');
        try { sessionStorage.setItem(DATA_KEY, JSON.stringify(data)); } catch (e) {}
        makes = prep(data.makes);
        return makes;
      })
      .catch(function () { makes = []; return makes; });
    return bikesLoading;
  }

  /* The bike named in a search. Model names match with spaces and dashes ignored ("drz400sm" = "DR-Z400SM");
     short ones ("One", "805", "450 SMR") only next to their make. Years are ignored. A make plus a number with
     several models ("ktm 450") asks which one; a make alone lists its models. */
  function findBike(q) {
    if (!makes || !makes.length) return null;
    var words = norm(q).split(' ').filter(function (w) { return w && !YEAR.test(w); });
    var qc = words.join('');
    if (qc.length < 3) return null;
    var makeHit = null;
    var hits = [];
    makes.forEach(function (m) {
      var named = m.key.length >= 3 && qc.indexOf(m.key) >= 0;
      if (named && (!makeHit || m.key.length > makeHit.key.length)) makeHit = m;
      m.models.forEach(function (md) {
        if (md.key.length >= 2 && qc.indexOf(md.key) >= 0 && (named || md.key.length >= 5)) hits.push({ make: m, model: md, named: named });
      });
    });
    if (makeHit) hits = hits.filter(function (h) { return h.make === makeHit; });
    if (hits.length) {
      hits.sort(function (a, b) { return b.model.key.length - a.model.key.length; });
      var best = hits[0];
      var same = hits.filter(function (h) { return h.model.key === best.model.key; });
      if (same.length > 1) return { kind: 'pick', title: best.model.label, options: same };
      return { kind: 'model', make: best.make, model: best.model };
    }
    if (makeHit) {
      var nums = words.filter(function (w) { return /^\d{2,4}$/.test(w); });
      var fam = nums.length ? makeHit.models.filter(function (md) { return nums.indexOf(md.lead) >= 0; }) : [];
      /* Letters typed after the make narrow it as you type: "ktm 400 e" -> 400 EXC (2026-10-25, Sheldon). */
      var tail = qc.slice(qc.indexOf(makeHit.key) + makeHit.key.length);
      if (tail.length >= 3) {
        var pre = (fam.length ? fam : makeHit.models).filter(function (md) { return md.key.indexOf(tail) === 0; });
        if (pre.length) fam = pre;
      }
      if (fam.length === 1) return { kind: 'model', make: makeHit, model: fam[0] };
      if (fam.length > 1) return { kind: 'family', make: makeHit, title: makeHit.label + ' ' + fam[0].lead, models: fam };
      return { kind: 'make', make: makeHit, title: makeHit.label, models: makeHit.models };
    }
    return null;
  }

  /* Wheel builder for a bike: the E-Moto builder for e-moto makes; for gas bikes the Supermoto builder when the
     model is a supermoto (SM, SMR, SMC, Supermoto), else the first Gas-Moto builder (Offroad). */
  function builderFor(make, model) {
    var mine = builders.filter(function (b) { return b.type === make.group && okUrl(b.url); });
    if (!mine.length) return null;
    if (make.group === 'Gas-Moto' && model && /(^| )(sm|smr|smc|supermoto)( |$)|\dsm$/.test(norm(model.label))) {
      var sm = mine.filter(function (b) { return /supermoto/i.test(b.label + ' ' + b.url) && !/tubeless/i.test(b.label + ' ' + b.url); })[0];
      if (sm) return sm;
    }
    return mine[0];
  }

  /* ---- counts and "fits your bike", from the two small templates; cached for the visit ---- */
  var collCache = {};
  var fitCache = {};
  function collInfo(handle) {
    if (!handle) return Promise.resolve(null);
    if (collCache[handle]) return collCache[handle];
    var ck = 'w9s_c_' + handle;
    try {
      var c = JSON.parse(sessionStorage.getItem(ck) || 'null');
      if (c) { fitCache[handle] = c; return (collCache[handle] = Promise.resolve(c)); }
    } catch (e) {}
    function page(n) {
      return fetch(ROOT + 'collections/' + encodeURIComponent(handle) + '?view=w9handles&page=' + n, { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (t) { return JSON.parse(t); });
    }
    collCache[handle] = page(1).then(function (first) {
      var rest = [];
      for (var i = 2; i <= Math.min(first.pages || 1, 8); i++) rest.push(page(i));
      return Promise.all(rest).then(function (more) {
        var info = { count: first.count, handles: more.reduce(function (all, p) { return all.concat(p.handles || []); }, first.handles || []) };
        try { sessionStorage.setItem(ck, JSON.stringify(info)); } catch (e) {}
        fitCache[handle] = info;
        return info;
      });
    }).catch(function () { return null; });
    return collCache[handle];
  }
  function suggest(q, signal) {
    var u = ROOT + 'search/suggest.json?q=' + encodeURIComponent(q) +
      '&resources[type]=product,collection,query&resources[limit]=6&resources[limit_scope]=each' +
      '&resources[options][unavailable_products]=last';
    return fetch(u, { signal: signal, credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (j) { return (j.resources && j.resources.results) || {}; });
  }
  function countFor(q, signal) {
    return fetch(SEARCH + '?view=w9count&type=product&q=' + encodeURIComponent(q), { signal: signal, credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (t) { try { return JSON.parse(t).count; } catch (e) { return null; } })
      .catch(function () { return null; });
  }

  /* ---- panel open / close ---- */
  function place() {
    if (desk.matches) { panel.style.top = ''; return; }
    panel.style.top = Math.max(0, form.getBoundingClientRect().bottom + 6) + 'px';
  }
  function open() {
    if (!panel.hidden) return;
    panel.hidden = false;
    input.setAttribute('aria-expanded', 'true');
    if (!desk.matches) {
      document.documentElement.classList.add('w9s-open');
      if (cancel) cancel.hidden = false;
      place();
    }
    loadBikes().then(function () { if (!panel.hidden) { lastQ = null; run(); } });
  }
  function close() {
    if (panel.hidden) return;
    panel.hidden = true;
    input.setAttribute('aria-expanded', 'false');
    document.documentElement.classList.remove('w9s-open');
    if (cancel) cancel.hidden = true;
  }

  /* ---- rendering ---- */
  function chips(list) {
    var box = el('div', 'w9s__chips');
    list.forEach(function (t) {
      var b = el('button', 'w9s__chip', t);
      b.type = 'button';
      b.setAttribute('data-w9s-q', t);
      box.appendChild(b);
    });
    return box;
  }
  function show(nodes, cls) {
    body.className = 'w9s__body' + (cls ? ' ' + cls : '');
    body.textContent = '';
    nodes.forEach(function (n) { if (n) body.appendChild(n); });
  }
  function renderEmpty() {
    var box = el('div', 'w9s__empty');
    if (popular.length) { box.appendChild(el('span', 'w9s__h', 'Popular searches')); box.appendChild(chips(popular)); }
    var bike = readBike();
    var tip = el('div', 'w9s__tip');
    if (bike && okUrl(bike.url)) {
      tip.appendChild(el('span', '', 'Your bike: ' + bike.label));
      tip.appendChild(link(bike.url, 'w9s__tipbtn', 'Shop its parts'));
    } else {
      tip.appendChild(el('span', '', 'Search by bike: type a make or model, like light bee or drz400sm.'));
      var pick = el('button', 'w9s__tipbtn', 'Select your bike');
      pick.type = 'button';
      pick.setAttribute('data-w9h-bike-toggle', '');
      tip.appendChild(pick);
    }
    box.appendChild(tip);
    show([box]);
  }
  function renderNone(q) {
    var box = el('div', 'w9s__empty');
    box.appendChild(el('strong', 'w9s__none', 'No parts match “' + q + '”'));
    box.appendChild(el('span', 'w9s__sub', "Check the spelling or number, or send it to us and we'll find the part."));
    var row = el('div', 'w9s__row');
    var chat = link(cfg.contactUrl || '/pages/contact-us-info', 'w9s__cta', 'Ask Warp 9');
    chat.setAttribute('data-w9h-chat', '');
    row.appendChild(chat);
    if (cfg.phone) row.appendChild(link('tel:' + cfg.phoneTel, 'w9s__cta w9s__cta--ghost', 'Call ' + cfg.phone));
    box.appendChild(row);
    if (popular.length) { box.appendChild(el('span', 'w9s__h', 'Popular searches')); box.appendChild(chips(popular)); }
    show([box]);
  }

  function bikeCard(hit, saved, cols) {
    var card = el('div', 'w9s__bike');
    card.appendChild(el('span', 'w9s__h', 'Bike in your search'));
    if (hit.kind === 'model') {
      var name = hit.make.label + ' ' + hit.model.label;
      var mine = saved && saved.make === hit.make.label && saved.model === hit.model.label;
      if (mine) card.classList.add('is-mine');
      card.appendChild(el('strong', 'w9s__bikename', name));
      /* The red button goes to the model's own page only, never a whole make (2026-10-25, Sheldon). */
      var broad = !modelPage(hit.make, hit.model);
      if (!broad) {
        var shop = link(hit.model.url, 'w9s__btn', 'Shop ' + hit.model.label + ' parts');
        shop.appendChild(el('span', '', '→'));
        card.appendChild(shop);
        collInfo(collHandle(hit.model.url)).then(function (info) {
          if (info && info.count) shop.firstChild.textContent = 'Shop ' + info.count + ' ' + hit.model.label + ' parts';
        });
      }
      wheel(card, hit.make, hit.model);
      if (mine) card.appendChild(el('span', 'w9s__mine', '✓ Your bike'));
      else if (!broad) {
        var save = el('button', 'w9s__save', 'Save as My bike');
        save.type = 'button';
        save.setAttribute('data-w9s-save', '');
        save.w9bike = { label: name, url: hit.model.url, make: hit.make.label, model: hit.model.label };
        card.appendChild(save);
      }
      return card;
    }
    card.appendChild(el('strong', 'w9s__bikename', hit.title));
    var list = hit.kind === 'pick' ? hit.options.map(function (o) { return { label: o.make.label + ' ' + o.model.label, url: o.model.url, ok: modelPage(o.make, o.model) }; })
      : hit.models.map(function (md) { return { label: md.label, url: md.url, ok: modelPage(hit.make, md) }; });
    list = list.filter(function (o) { return o.ok; });
    if (list.length) {
      card.appendChild(el('span', 'w9s__sub', 'Which ' + hit.title + '?'));
      var models = el('div', 'w9s__models');
      list.slice(0, 8).forEach(function (o) { models.appendChild(link(o.url, 'w9s__model', o.label)); });
      if (list.length > 8) models.appendChild(el('span', 'w9s__more', '+' + (list.length - 8) + ' more'));
      card.appendChild(models);
    }
    /* No "Shop all <make> parts" button: a broad make page isn't the answer to a model search; the model
       chips above lead to each model's own page (2026-10-25, Sheldon). */
    if (hit.make) wheel(card, hit.make, null);
    return card;
  }
  function wheel(card, make, model) {
    var b = builderFor(make, model);
    if (!b) return;
    var a = link(b.url, 'w9s__btn w9s__btn--ghost', 'Build wheels for it');
    if (b.label || b.note) a.appendChild(el('small', '', [b.label, b.note].filter(Boolean).join(' · ')));
    card.appendChild(a);
  }

  function allLink(q) {
    var all = link(SEARCH + '?q=' + encodeURIComponent(q) + '&type=product', 'w9s__all', 'See all results for “' + q + '”');
    all.appendChild(el('span', '', 'Enter ↵'));
    return all;
  }
  /* Shown when Shopify is slow to answer (some part-number searches take several seconds). */
  function renderSearching(q) {
    show([el('div', 'w9s__empty w9s__searching', 'Searching for “' + q + '”…'), allLink(q)]);
  }
  function setTotal(q, n) {
    var all = body.querySelector('.w9s__all');
    if (all) all.firstChild.textContent = 'See all ' + n + ' results for “' + q + '”';
  }
  function fitBadge(saved) { return el('span', 'w9s__fit', 'Fits your ' + (saved.model || saved.label)); }
  function markFits(info, saved) {
    Array.prototype.forEach.call(body.querySelectorAll('.w9s__item[data-h]'), function (a) {
      var mid = a.querySelector('.w9s__mid');
      if (mid && !mid.querySelector('.w9s__fit') && info.handles.indexOf(a.getAttribute('data-h')) >= 0) mid.appendChild(fitBadge(saved));
    });
  }

  function render(q, r, hit, saved, fit) {
    var products = (r.products || []).slice();
    var cols = (r.collections || []).filter(function (c) { return !isMakePage(c.url); });
    var sugg = (r.queries || []).filter(function (x) { return norm(x.text) !== norm(q); }).slice(0, 3);
    if (!products.length && !cols.length && !hit) { renderNone(q); fire('w9:search', { q: q, products: 0, bike: '' }); return; }

    /* Parts that fit the saved bike first, then parts naming the bike in the search; otherwise Shopify's order. */
    var fits = fit && fit.handles ? fit.handles : null;
    var named = hit && hit.kind === 'model' ? hit.model.key : hit && hit.make ? hit.make.key : '';
    products = products.map(function (p, i) {
      var score = (fits && fits.indexOf(prodHandle(p.url)) >= 0 ? 2 : 0) + (named && compact(p.title).indexOf(named) >= 0 ? 1 : 0);
      return { p: p, i: i, s: score };
    }).sort(function (a, b) { return (b.s - a.s) || (a.i - b.i); }).map(function (x) { return x.p; });

    var side = el('div', 'w9s__side');
    if (hit) side.appendChild(bikeCard(hit, saved, cols));
    if (cols.length) {
      var cb = el('div', 'w9s__group');
      cb.appendChild(el('span', 'w9s__h', 'Collections'));
      cols.slice(0, 4).forEach(function (c) { cb.appendChild(link(c.url, 'w9s__link', c.title)); });
      side.appendChild(cb);
    }
    if (sugg.length) {
      var sb = el('div', 'w9s__group');
      sb.appendChild(el('span', 'w9s__h', 'Searches'));
      sugg.forEach(function (x) {
        var b = el('button', 'w9s__q', x.text);
        b.type = 'button';
        b.setAttribute('data-w9s-q', x.text);
        sb.appendChild(b);
      });
      side.appendChild(sb);
    }

    var main = el('div', 'w9s__main');
    main.appendChild(el('span', 'w9s__h', 'Products'));
    products.forEach(function (p) {
      var a = link(p.url, 'w9s__item');
      a.setAttribute('data-h', prodHandle(p.url));
      var img = el('span', 'w9s__img');
      var src = p.featured_image && p.featured_image.url ? p.featured_image.url : p.image;
      if (src) {
        var i = el('img');
        i.src = src + (src.indexOf('?') >= 0 ? '&' : '?') + 'width=120';
        i.alt = '';
        i.loading = 'lazy';
        i.width = 56;
        i.height = 56;
        img.appendChild(i);
      }
      a.appendChild(img);
      var mid = el('span', 'w9s__mid');
      mid.appendChild(el('span', 'w9s__title', p.title));
      if (fits && fits.indexOf(prodHandle(p.url)) >= 0) mid.appendChild(fitBadge(saved));
      a.appendChild(mid);
      var pr = el('span', 'w9s__price');
      pr.appendChild(el('strong', '', money(p.price)));
      var was = parseFloat(p.compare_at_price_max);
      if (was > parseFloat(p.price)) pr.appendChild(el('s', 'w9s__was', money(was)));
      a.appendChild(pr);
      main.appendChild(a);
    });
    if (!products.length) main.appendChild(el('span', 'w9s__sub', 'No products match these words. Try the bike or collections.'));

    var grid = el('div', 'w9s__grid' + (side.childNodes.length ? '' : ' is-single'));
    if (side.childNodes.length) grid.appendChild(side);
    grid.appendChild(main);
    show([grid, allLink(q)]);
    fire('w9:search', { q: q, products: products.length, bike: hit && hit.kind === 'model' ? hit.make.label + ' ' + hit.model.label : '' });
  }

  /* ---- typing: suggestions show as soon as Shopify answers; the count and "fits" tags fill in after ---- */
  var seq = 0;
  var ctl = null;
  var timer = 0;
  var slow = 0;
  var lastQ = null;
  function run() {
    var q = input.value.trim();
    if (q === lastQ) return;
    lastQ = q;
    if (ctl) { ctl.abort(); ctl = null; }
    clearTimeout(slow);
    var my = ++seq;
    if (!q) { renderEmpty(); return; }
    ctl = window.AbortController ? new AbortController() : null;
    var sig = ctl ? ctl.signal : undefined;
    var saved = readBike();
    var savedHandle = saved ? collHandle(saved.url) : '';
    if (savedHandle) collInfo(savedHandle);
    body.classList.add('is-busy');
    slow = setTimeout(function () { if (my === seq) renderSearching(q); }, 450);
    var counted = countFor(q, sig);
    Promise.all([suggest(q, sig), loadBikes()])
      .then(function (res) {
        if (my !== seq) return;
        clearTimeout(slow);
        render(q, res[0], findBike(q), saved, savedHandle ? fitCache[savedHandle] : null);
        counted.then(function (n) { if (my === seq && n) setTotal(q, n); });
        if (savedHandle && !fitCache[savedHandle]) collInfo(savedHandle).then(function (info) { if (my === seq && info) markFits(info, saved); });
      })
      .catch(function (e) {
        if (my !== seq || (e && e.name === 'AbortError')) return;
        clearTimeout(slow);
        lastQ = null;
        show([el('div', 'w9s__empty', "Search didn't load. Press Enter to see all results."), allLink(q)]);
      });
  }
  function queue() { clearTimeout(timer); timer = setTimeout(run, 160); }

  input.addEventListener('focus', function () { open(); queue(); });
  input.addEventListener('input', function () { open(); queue(); });
  input.addEventListener('keydown', function (e) {
    if (e.key === 'ArrowDown') { var f = items()[0]; if (f) { e.preventDefault(); f.focus(); } }
    else if (e.key === 'Escape') close();
  });
  form.addEventListener('submit', function (e) { if (!input.value.trim()) e.preventDefault(); });
  if (cancel) cancel.addEventListener('click', function () { input.blur(); close(); });

  function items() { return Array.prototype.slice.call(panel.querySelectorAll('a[href], button')); }
  panel.addEventListener('keydown', function (e) {
    var list = items();
    var i = list.indexOf(document.activeElement);
    if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
      e.preventDefault();
      var n = i + (e.key === 'ArrowDown' ? 1 : -1);
      if (n < 0) input.focus(); else if (list[n]) list[n].focus();
    } else if (e.key === 'Escape') { close(); input.focus(); }
  });
  panel.addEventListener('click', function (e) {
    var t = e.target;
    var qb = t.closest('[data-w9s-q]');
    if (qb) { input.value = qb.getAttribute('data-w9s-q'); input.focus(); run(); return; }
    var save = t.closest('[data-w9s-save]');
    if (save && save.w9bike) {
      try { localStorage.setItem(KEY, JSON.stringify(save.w9bike)); } catch (err) {}
      /* Same as the header's Save my bike: reload a product page so its fit check updates, else go to the parts. */
      if (document.body.classList.contains('template-product')) window.location.reload();
      else window.location.href = save.w9bike.url;
      return;
    }
    if (t.closest('[data-w9h-bike-toggle]')) { close(); return; }
    var a = t.closest('a[href]');
    if (a) fire('w9:search-click', { q: input.value.trim(), href: a.getAttribute('href'), text: a.textContent.trim() });
  });
  document.addEventListener('click', function (e) {
    if (!panel.hidden && !form.contains(e.target)) close();
  });
  window.addEventListener('resize', function () { if (!panel.hidden) place(); });
  var onBp = function () { close(); };
  if (desk.addEventListener) desk.addEventListener('change', onBp); else if (desk.addListener) desk.addListener(onBp);
})();
